import { Product, UTSLocale } from "@smile2impress/attraction-constants";
import {
    ComponentMultiColumnColumnType,
    ComponentMultiColumnItemProps,
} from "api/cms-website";
import {
    ColumnProps,
    DoctorsProfileProps,
    SimpleColumnProps,
} from "templates/relaunch/MultiColumn/components";

import { replaceTreatmentCasePlaceholders } from "utils/replaceTreatmentCasePlaceholders";

import { mapImage } from "./mapImage";

export function mapMultiColumnItems<T extends ComponentMultiColumnItemProps>({
    items,
    products,
    locale,
    columnType,
}: {
    items: T[];
    products: Product[];
    locale: UTSLocale;
    columnType: ComponentMultiColumnColumnType;
}):
    | SimpleColumnProps[]
    | ColumnProps[]
    | DoctorsProfileProps[]
    | (SimpleColumnProps | ColumnProps | DoctorsProfileProps)[] {
    return items?.map((item) => {
        switch (columnType) {
            case ComponentMultiColumnColumnType.PRODUCTS: {
                const mappedImage = mapImage(item.image);
                return {
                    title: item.title,
                    subtitle: replaceTreatmentCasePlaceholders(item.text, {
                        products,
                        locale,
                    }),
                    ...((mappedImage?.defaultSrc ||
                        (Array.isArray(mappedImage?.images) &&
                            mappedImage?.images?.length)) && {
                        image: mappedImage,
                    }),
                    link: item.link?.href,
                    ...(item.icon?.type && { icon: item.icon.type }),
                } as SimpleColumnProps;
            }
            case ComponentMultiColumnColumnType.LONG_TEXT: {
                const mappedImage = mapImage(item.image);
                return {
                    title: item.title,
                    text: item.text,
                    withSeparator: true,
                    withExpandableText: false,
                    ...((mappedImage?.defaultSrc ||
                        (Array.isArray(mappedImage?.images) &&
                            mappedImage?.images?.length)) && {
                        image: { image: mappedImage },
                    }),
                    link: item.link?.href,
                    ...(item.icon?.type && { icon: item.icon.type }),
                } as ColumnProps;
            }
            case ComponentMultiColumnColumnType.ICONS:
                return {
                    title: item.title,
                    text: item.text,
                    ...(item.icon?.type && { icon: item.icon.type }),
                    ...(item.link?.href && { link: item.link.href }),
                } as ColumnProps;
            case ComponentMultiColumnColumnType.DOCTORS: {
                const mappedImage = mapImage(item.image);
                return {
                    title: item.title,
                    text: item.text,
                    ...((mappedImage?.defaultSrc ||
                        (Array.isArray(mappedImage?.images) &&
                            mappedImage?.images?.length)) && {
                        image: mappedImage,
                    }),
                    ...(item.iconLocale && {
                        iconLocale: item.iconLocale.replace(
                            "_",
                            "-"
                        ) as UTSLocale,
                    }),
                } as DoctorsProfileProps;
            }
        }
    });
}
